import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';

// Layout & Common
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import './styles/index.css';

// Pages
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import ServiceDetail from './pages/ServiceDetail';

// Admin Pages
import Login from './pages/admin/Login';
import AdminLayout from './components/admin/AdminLayout';
import DashboardOverview from './pages/admin/DashboardOverview';
import ManageServices from './pages/admin/ManageServices';
import ManageAbout from './pages/admin/ManageAbout';
import ViewInquiries from './pages/admin/ViewInquiries';
import ManageHero from './pages/admin/ManageHero';
import ManageClients from './pages/admin/ManageClients';

function App() {
    return (
        <HelmetProvider>
            <AuthProvider>
                <BrowserRouter>
                    <div className="App">
                        <Routes>
                            {/* Public Routes with Navbar/Footer */}
                            <Route path="/" element={<><Navbar /><Home /><Footer /></>} />
                            <Route path="/services" element={<><Navbar /><Services /><Footer /></>} />
                            <Route path="/services/:slug" element={<><Navbar /><ServiceDetail /><Footer /></>} />
                            <Route path="/about" element={<><Navbar /><About /><Footer /></>} />
                            <Route path="/contact" element={<><Navbar /><Contact /><Footer /></>} />

                            {/* Admin Routes */}
                            <Route path="/admin/login" element={<Login />} />
                            <Route
                                path="/admin"
                                element={
                                    <ProtectedRoute>
                                        <AdminLayout />
                                    </ProtectedRoute>
                                }
                            >
                                <Route index element={<DashboardOverview />} />
                                <Route path="services" element={<ManageServices />} />
                                <Route path="about" element={<ManageAbout />} />
                                <Route path="inquiries" element={<ViewInquiries />} />
                                <Route path="hero" element={<ManageHero />} />
                                <Route path="clients" element={<ManageClients />} />
                            </Route>
                        </Routes>
                    </div>
                </BrowserRouter>
            </AuthProvider>
        </HelmetProvider>
    );
}

export default App;
